export default "__VITE_PUBLIC_ASSET__0f4b6106__"